<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14.8438 10.1562L17.1875 12.5L14.8438 14.8437M10.1562 14.8438L7.8125 12.5L10.1562 10.1563M6.25 21.0938H18.75C20.0444 21.0938 21.0938 20.0444 21.0938 18.75V6.25C21.0938 4.95558 20.0444 3.90625 18.75 3.90625H6.25C4.95558 3.90625 3.90625 4.95558 3.90625 6.25V18.75C3.90625 20.0444 4.95558 21.0938 6.25 21.0938Z"
				:stroke="color"
				stroke-width="1.5625"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgCode',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
